import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import grey from '@material-ui/core/colors/grey';

const styles = theme => ({
    margin: {
        margin: 0,
        padding: '10px'
    },
    cssRoot: {
        // color: theme.palette.getContrastText(grey[500]),
        backgroundColor: grey[500],
        '&:hover': {
            backgroundColor: grey[700],
        },
    },
    formControl: {
        // margin: theme.spacing.unit,
        marginTop: '105px',
        marginBottom: 0,
        width: '100%'
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        // marginLeft: theme.spacing.unit,
        // marginRight: theme.spacing.unit,
        // backgroundColor: '#fff',
    },
    dense: {
        marginTop: 16,
    },
    menu: {
        width: 200,
    },
    button: {
        margin: theme.spacing.unit,
        // margin: 16,
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 20,
    },
    cssLabel: {
        '&$cssFocused': {
            color: '#000',
        },
    },
    cssFocused: {},
    cssInput: {
        textAlign: 'center',
        backgroundColor: '#fff',
        borderRadius: '4px'
    }
});

class SearchForm extends React.Component {
    constructor(props) {
        super(props);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const {onSubmit} = this.props;
        onSubmit();
    };

    handleChange = (e) => {
        const {onChange} = this.props;
        onChange({[e.target.id]: e.target.value});
    };

    render() {
        const { vat, supplyCode, classes, isSearchClicked } = this.props;
        return (
            <form className={"package-form"} noValidate autoComplete="off">
                <div>
                    <input
                        type="text"
                        id="supplyCode"
                        value={supplyCode}
                        onChange={this.handleChange}
                        placeholder={"ΚΩΔΙΚΟΣ ΠΕΛΑΤΗ"}
                        className={"custom-input"}
                    />

                </div>
                <div>
                    <input
                        type="text"
                        id="vat"
                        value={vat}
                        onChange={this.handleChange}
                        placeholder={"ΑΦΜ"}
                        className={"custom-input"}
                    />
                </div>
                <FormControl className={classes.formControl}>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classNames(classes.margin, classes.cssRoot)}
                        onClick={this.handleSubmit}
                        fullWidth
                        disabled={isSearchClicked}
                    >
                        {"ΑΝΑΖΗΤΗΣΗ"}
                    </Button>
                </FormControl>
            </form>
        )
    }
}

export default withStyles(styles)(SearchForm);